import useDarkMode from '@/utils/hooks/utils/useDarkMode';

type BlueSkyIconProps = React.ComponentPropsWithRef<'svg'>;

export function BlueSkyIcon({ ...restProps }: BlueSkyIconProps) {
    const { isDarkMode } = useDarkMode();

    if (isDarkMode()) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...restProps}>
                <path
                    d="M12 10.8C10.913 8.686 7.954 4.747 5.202 2.805C2.566 0.944001 1.561 1.266 0.902 1.565C0.139 1.908 0 3.08 0 3.768C0 4.458 0.378 9.418 0.624 10.247C1.439 12.983 4.337 13.907 7.007 13.611C7.143 13.591 7.282 13.572 7.422 13.555C7.284 13.577 7.146 13.595 7.007 13.611C3.095 14.191 -0.38 15.616 4.177 20.689C9.19 25.879 11.047 19.576 12 16.381C12.953 19.576 14.05 25.652 19.733 20.689C24 16.381 20.905 14.191 16.993 13.611C16.8542 13.5957 16.7159 13.577 16.578 13.555C16.718 13.572 16.857 13.591 16.993 13.611C19.663 13.908 22.561 12.983 23.376 10.247C23.622 9.419 24 4.457 24 3.769C24 3.079 23.861 1.908 23.098 1.563C22.439 1.265 21.434 0.943001 18.798 2.803C16.046 4.748 13.087 8.687 12 10.8Z"
                    fill="white"
                />
            </svg>
        );
    }

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}>
            <path
                d="M12 10.8C10.913 8.686 7.954 4.747 5.202 2.805C2.566 0.944001 1.561 1.266 0.902 1.565C0.139 1.908 0 3.08 0 3.768C0 4.458 0.378 9.418 0.624 10.247C1.439 12.983 4.337 13.907 7.007 13.611C7.143 13.591 7.282 13.572 7.422 13.555C7.284 13.577 7.146 13.595 7.007 13.611C3.095 14.191 -0.38 15.616 4.177 20.689C9.19 25.879 11.047 19.576 12 16.381C12.953 19.576 14.05 25.652 19.733 20.689C24 16.381 20.905 14.191 16.993 13.611C16.8542 13.5957 16.7159 13.577 16.578 13.555C16.718 13.572 16.857 13.591 16.993 13.611C19.663 13.908 22.561 12.983 23.376 10.247C23.622 9.419 24 4.457 24 3.769C24 3.079 23.861 1.908 23.098 1.563C22.439 1.265 21.434 0.943001 18.798 2.803C16.046 4.748 13.087 8.687 12 10.8Z"
                fill="#0285FF"
            />
        </svg>
    );
}
